import { createRouter, createWebHistory } from 'vue-router'
import Dashboard from '../views/Dashboard.vue'
import Login from '../views/Login.vue'
import Clienti from '../views/Clienti.vue'
import Statistiche from '../views/Statistiche.vue'
import Agenti from '../views/Agenti.vue'
import Scadenzari from '../views/Scadenzari.vue'
import Utenti from '../components/common/Utenti.vue'
import Amministratori from '../views/Amministratori.vue'
import Fatture from '../views/Fatture.vue'
import Pagamenti from '../views/Pagamenti.vue'
import Logs from '../views/Logs.vue'
import Contratti from '../views/Contratti.vue'






const routes = [
    {path: '/login',  name: 'Login',    component: Login},
    {path: '/dashboard',  name: 'Dashboard',    component: Dashboard},
    {path: '/clienti',  name: 'Clienti',    component: Clienti},
    {path: '/statistiche',  name: 'Statistiche',    component: Statistiche},
    {path: '/agenti',  name: 'Agenti',    component: Agenti},
    {path: '/fatture',  name: 'Fatture',    component: Fatture},
    {path: '/utenti',  name: 'Utenti',    component: Utenti},
    {path: '/scadenzari',  name: 'Scadenzari',    component: Scadenzari},
    {path: '/amministratori',  name: 'Amministratori',    component: Amministratori},
    {path: '/pagamenti',  name: 'Pagamenti',    component: Pagamenti},
    {path: '/logs',  name: 'Logs',    component: Logs},
    {path: '/contratti',  name: 'Contratti',    component: Contratti},

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
